class HeroSlider {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('.hero-slide'));
    this.dots = Array.from(root.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = root.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = root.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.autoplay = root.dataset.autoplay === 'true';
    this.speed = parseInt(root.dataset.speed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');

    this.current = (index + this.slides.length) % this.slides.length;

    this.slides[this.current].classList.add('is-active');
    if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
  }

  next() {
    this.goTo(this.current + 1);
  }

  prev() {
    this.goTo(this.current - 1);
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  bindEvents() {
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.next();
        if (this.autoplay) this.startAutoplay();
      });
    }

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prev();
        if (this.autoplay) this.startAutoplay();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.index, 10));
        if (this.autoplay) this.startAutoplay();
      });
    });

    this.root.addEventListener('mouseenter', () => this.stopAutoplay());
    this.root.addEventListener('mouseleave', () => {
      if (this.autoplay) this.startAutoplay();
    });

    // Touch swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    this.root.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.root.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? this.next() : this.prev();
        if (this.autoplay) this.startAutoplay();
      }
    }, { passive: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.hero-slider').forEach((el) => new HeroSlider(el));
});



